import { Box, Button, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { useState } from "react";
// import { UserAndConversations } from 'src/models/userAndConversations';

import SearchIcon from "@mui/icons-material/Search";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function TextFieldNews({ searchText, setSearchText }) {
    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value);
    };

    return (
        <Grid container justifyContent="center" spacing={2} pt={1.5} pb={1.5}>
            <Grid item xs={12}>
                <Box bgcolor={PureLightThemeCaaS.colors.alpha.black[100]}>
                    <Stack direction={{ xs: "row", lg: "row" }} justifyContent={{ xs: "center", lg: "center" }} alignItems="center">
                        <TextField
                            id="outlined-basic"
                            label="Search news"
                            variant="outlined"
                            color="info"
                            autoComplete="off"
                            value={searchText}
                            onChange={handleSearchTextChange}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ pt: 0.2 }} />,
                                style: { color: PureLightThemeCaaS.colors.alpha.white[100], height: "36px", paddingLeft: "10px", paddingBottom: "5px" },
                            }}
                            InputLabelProps={{
                                style: {
                                    color: PureLightThemeCaaS.colors.alpha.white[100],
                                },
                            }}
                            sx={{
                                width: "300px",
                                "& .MuiInputBase-root": {
                                    height: "36px",
                                },
                                "& .MuiInputLabel-outlined": {
                                    transform: "translate(14px, 6px) scale(1)", // Initial position
                                    "&.MuiInputLabel-shrink": {
                                        transform: "translate(20px, -9px) scale(0.75)", // Position wheon shrinked
                                    },
                                },
                            }}
                        />
                    </Stack>
                </Box>
            </Grid>
        </Grid>
    );
}

export default TextFieldNews;
